import { Tree } from "primereact/tree";
import { useEffect, useRef, useState } from "react";
import { AddKeyToNodes } from "../components/AddKeyToNodes";

import { Splitter, SplitterPanel } from 'primereact/splitter';
import { LocalServer, S3Icon, SharePointIcon } from "../icon_templates/icons";
import { FileExplorerView } from "../components/FileExplorerView";
import { FileDetailedView } from "../components/FileDetailedView";
import { AddStorageModal } from "../components/AddStorageModal";
import { setCollections } from "../common_functions/slicers";
import { setBackendId } from "../common_functions/slicers";
import {
  faTrash,
  faPencilAlt,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../assets/styles/explorer.css"

import { useDispatch, useSelector } from "react-redux";
import * as bootstrap from 'bootstrap';
import { delete_backend_connection, get_mapped_collections_list } from "../assets/constants/global_apis";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { get_tags_list, get_mapped_tags_list, download_files } from "../assets/constants/global_apis";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { CustomizedTagSelector } from "../components/TagSelector";
import { get_all_collections, add_videos_to_collection, createNewCollection, delete_files_from_folder } from "../assets/constants/global_apis";
import AlertPopup from "../components/AlertMessage";
import { triggerAlert } from "../components/AlertMessage";
import MultiFileUploadWithBottomProgressBar from "../components/MultipleFileUploader";
import { decodeUrlEncodedString } from "../common_functions/video_annotator_functions";
import { create_new_folder } from "../assets/constants/global_apis";

const modalStyle = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  height: 175,
  pt: 2,
  paddingLeft: 0,
  paddingRight: 0,
  padding: '30px'
};



export default function Explorer() {
  const [backend_lists, setBackendLists] = useState([]);
  const [backend_details, setBackendDetails] = useState([]);
  const [selected_backend_id, setSelectedBackendId] = useState();
  const [selected_node, setSelectedNode] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [fileDetails, setFileDetails] = useState();
  const [selectedKey, setSelectedKey] = useState({});
  const [flatNodes, setFlatNodes] = useState([]); // flat list of nodes for easy indexing
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isFolderView, setIsFolderView] = useState(false);
  const [isFileView, setIsFileView] = useState(false);
  const [explorer_details, setExplorerDetails] = useState([]);
  const [selectedPath, setSelectedPath] = useState('');
  const [backendTypes, setBackendTypes] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isFolderViewOpen, setIsFolderViewOpen] = useState(false);
  const [folderSelectedFiles, setFolderSelectedFiles] = useState([]);
  const [completePath, setCompletePath] = useState("");
  const [openFileUploadModal, setOpenFileUploadModal] = useState(false);
  const [editBackend, seteditBackend] = useState({
    edit: false,
    currentBackend: {}
  });
  const [testConnectionStatus, setTestConnectionStatus] = useState('');
  const [buttonAction, setbuttonAction] = useState({
    backend: {},
    event: '',
    index: -1,
    eventMessage: ''
  })
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState({
    "auth_key": "",
    "auth_secret": "",
    "auth_url": "",
    "backend_name": "",
    "description": "",
    "root_dir": "",
    "type": ""
  });

  const [tagsList, setTagsList] = useState([])
  const [mappedTags, setMappedTags] = useState([])
  const [mappedTags1, setMappedTags1] = useState([])
  const [openModalType, setOpenModalType] = useState("");

  const [collectionsList, setCollectionsList] = useState([]);
  const [mappedCollection, setMappedCollection] = useState([])
  const [mappedCollection1, setMappedCollection1] = useState([])
  const [openCollectionsModal, setOpenCollectionsModal] = useState(false);


  const [uploadFolderPath, setUploadFolderPath] = useState('');

  let [inputValue, setInputValue] = useState('')
  const [contextMenu, setContextMenu] = useState(null);
  const [folderReq, setFolderReq] = useState({
    path: ""
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const panelRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    const updateMaxWidth = () => {
      if (panelRef.current) {
        const width = panelRef.current.offsetWidth;
        setMaxWidth(width);
      }
    };

    updateMaxWidth(); // Initial call

    const resizeObserver = new ResizeObserver(() => {
      updateMaxWidth(); // Update on resize
    });

    if (panelRef.current) {
      resizeObserver.observe(panelRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const handleOpenCollectionModal = (action) => {
    if (action != '') {
      setMappedTags1([])
      setMappedCollection1([])
      fetchTagsDetails();
      fetchCollectionDetails();
      setOpenModalType(action)
    } else {
      setOpenModalType('tags')
    }
  }

  const handleCloseModal = () => {
    setOpenModalType('')
    setFolderReq({
      path: ""
    });
  }

  const flattenTree = (nodes) => {
    const flat = [];

    const recurse = (items) => {
      for (const node of items) {
        flat.push(node);
        if (node.children) recurse(node.children);
      }
    };

    recurse(nodes);
    return flat;
  };

  const fetchTagsDetails = () => {
    get_tags_list().then((data) => {
      setTagsList(data);
    })
  }

  const fetchCollectionDetails = () => {
    get_all_collections().then((data) => {
      setCollectionsList(data);
    })
  }

  const fetchVideoTagDetails = (path) => {
    if (path != '') {
      get_mapped_tags_list(path).then((data1) => {
        setMappedTags(data1.tags);
      }).catch(() => {
        setMappedTags([]);
      })
    }
  }

  const fetchVideoCollectionDetails = (path) => {
    if (path != '') {
      get_mapped_collections_list(path).then((data1) => {
        setMappedCollection(data1.collections);
      }).catch(() => {
        setMappedCollection([]);
      })
    }
  }


  const dispatch = useDispatch();
  const backendId = useSelector(state => state.collections.backendId);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setbuttonAction({
      backend: {},
      event: '',
      index: -1,
      eventMessage: ''
    });
    setOpen(false);
  };
  const handleButtonEventRemoveDelete = (event, backend, index) => {
    setbuttonAction({
      backend: backend,
      event: event,
      index: index,
      eventMessage: <span>Are you sure you want to delete <b>{backend.backend_name}</b>?</span>
    });
    handleOpen();
  }


  const handleButtonDeleteFiles = (event) => {
    setbuttonAction({
      event: event,
      eventMessage: <span>Are you sure you want to delete selected files?</span>
    });
    handleOpen();
  }



  const handleSubmitConfirmation = () => {
    if (buttonAction.event == 'Delete') {
      handleBackendDelete(buttonAction.backend, buttonAction.index)
    } if (buttonAction.event == 'Delete Files') {
      handleDeleteFiles();
    }
    setIsFolderView(false);
    setSelectedBackendId(backendId);
    setSelectedPath(-1);
    setBackendDetails([])
    handleClose('');
  }
  const getDetailsOfBackends = (backendId, depth, path, key) => {
    setLoading(true);
    setSelectedBackendId(backendId);
    setSelectedPath(path);
    fetch(`/api/v1/explore/${backendId}/${depth}?path=${path}`, {
      method: "GET",
      headers: {
        "Content-Type": "application",
      }
    }).then(response => response.json())
      .then(data => {
        setIsFileView(false);
        setExplorerDetails(data);
        if (path !== "") {
          const withChildren = insertIntoChildren(backend_details, data.sort((a, b) => b.is_dir - a.is_dir), key);
          const addNodes = AddKeyToNodes(withChildren);
          setBackendDetails(
            addNodes
          )
        }
        else {
          setBackendDetails(
            AddKeyToNodes(
              data.sort((a, b) => b.is_dir - a.is_dir)
            )
          );
        }
        // setTagsList([]);
        setMappedTags([]);
        setMappedTags1([])
        setMappedCollection([])
        setMappedCollection1([])
        setInputValue('')
        if (path?.split('.').length > 1 && tagsList?.length == 0) {
          fetchTagsDetails()
        }
        if (path?.split('.').length > 1 && collectionsList?.length == 0) {
          fetchCollectionDetails()
        }
        setIsFolderView(true);
        setLoading(false);
      })
      .catch(error => {
        setLoading(true);
      }
      );
  }

  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  function handleFileViewChange() {
    setIsFolderView(false);
    setIsFileView(true);
  }
  function handleFolderViewChange() {
    setIsFolderView(true);
    setIsFileView(false);
  }

  function insertIntoChildren(jsonArray, newJson, key) {
    for (let item of jsonArray) {
      if (item.key === key) {
        item.children = [];
        item.children.push(...newJson);
        return removeEmptyChildren(jsonArray); //jsonArray.filter((node) => !isEmptyObject(node));
      } else if (item.children && item.children.length > 0) {
        let result = insertIntoChildren(item.children, newJson, key);
        if (result) {
          return removeEmptyChildren(jsonArray);
        }
      }
    }
    return null;
  }

  function deleteFromNode(jsonArray, newJson, key) {
    for (let item of jsonArray) {
      if (item.key === key) {
        item.children = [];
        item.children = [...newJson];
        return removeEmptyChildren(jsonArray); //jsonArray.filter((node) => !isEmptyObject(node));
      } else if (item.children && item.children.length > 0) {
        let result = deleteFromNode(item.children, newJson, key);
        if (result) {
          return removeEmptyChildren(jsonArray);
        }
      }
    }
    return null;
  }

  const removeEmptyChildren = (nodes) => {
    return nodes.map(node => {
      if (node.children && Array.isArray(node.children)) {
        node.children = node.children.filter(child => !isEmptyObject(child));
        node.children = removeEmptyChildren(node.children); // Recursively clean children
      }
      return node;
    });
  };

  const getFileDtails = (backendId, path) => {
    setCompletePath(path);
    setIsFolderView(false);
    setIsFileView(true);
    setIsLoading(true);
    dispatch(setCollections({
      path: path,
      backendId: backendId
    }))
    Promise.all([
      fetch(`/api/v1/fetch/thumb/${backendId}/${path}`, {
        method: "GET",
      }).then(response => response.blob())
        .then(data => {
          let objectURL = URL.createObjectURL(data);
          setThumbnail(objectURL);
        })
        .catch(error => console.log(error)),

      fetch(`/api/v1/fetch/details/${backendId}/${path}`, {
        method: "GET",
      }).then(response => response.json())
        .then(data => {
          setFileDetails(data);
        })
        .catch(error => console.log(error))
    ]).finally(() => {
      setIsLoading(false);
    })
    // setTagsList([]);
    // setMappedTags([]);
    setMappedTags1([])
    setMappedCollection1([])
    setInputValue('')
    if (path?.split('.').length > 1) {
      fetchVideoTagDetails(path)
    }
    if (path?.split('.').length > 1) {
      fetchVideoCollectionDetails(path)
    }
  }

  const getBackendTypes = () => {
    fetch('/api/v1/backends/types', {
      method: "GET",
      headers: {
        "Content-Type": "application",
      }
    }).then(async (response) => {

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }
      return response.json()
    })
      .then(data => {
        setBackendTypes(data);
      })
      .catch(error => console.log(error));
  }

  const addTitle = () => {
    var list, index;
    list = document.getElementsByClassName("p-treenode-label");
    for (index = 0; index < list.length; ++index) {
      list[index].setAttribute('title', list[index].textContent);
    }

  }

  const getAllBackends = () => {
    fetch("/api/v1/backends/", {
      method: "GET",
      headers: {
        "Content-Type": "application",
      }
    }).then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        throw error;
      }
      return response.json()
    })
      .then(data => {
        setBackendLists(data);
        handleCloseEdit();
        closeModal();
      })
      .catch(error => console.log(error));
  }

  const closeModal = () => {
    var myModalEl = document.getElementById('addStorageModal');
    var modal = bootstrap.Modal.getInstance(myModalEl)
    modal && modal?.hide();
  }
  useEffect(() => {
    getAllBackends();
    fetchTagsDetails();
    fetchCollectionDetails();
    getAllSavedCollections();
  }, []);

  useEffect(() => {
    if (backend_details?.length > 0) {
      setFlatNodes(flattenTree(backend_details));
    }
  }, [backend_details]);

  const handleEditBackend = (backend, index) => {
    seteditBackend({
      edit: true,
      currentBackend: {
        ...backend
      }
    });
    setRequest({ ...backend });
  }
  const handleCloseEdit = () => {
    setTestConnectionStatus('')
    setRequest({
      "auth_key": "",
      "auth_secret": "",
      "auth_url": "",
      "backend_name": "",
      "description": "",
      "root_dir": "",
      "type": ""
    })
    seteditBackend({
      edit: false,
      currentBackend: {}
    })
  }

  const handleBackendDelete = (backend, index) => {
    delete_backend_connection(backend.id).then((data) => {
      let backendlst = [...backend_lists].filter((item, index1) => index1 != index);
      setBackendLists(backendlst);
    })
  }
  // Handle right-click for showing Download option
  const handleRightClick = (event, isFolderView, selectedFiles) => {
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let x = event?.originalEvent ? event.originalEvent.pageX : event.pageX;
    let y = event?.originalEvent ? event.originalEvent.pageY : event.pageY;

    // Adjust position if the context menu would overflow the viewport
    const menuHeight = 280; // Approximate height of the context menu
    const menuWidth = 150; // Approximate width of the context menu

    if (y + menuHeight > viewportHeight) {
      y = Math.max(viewportHeight - menuHeight, 0);
    }

    if (x + menuWidth > viewportWidth) {
      x = Math.max(viewportWidth - menuWidth, 0);
    }
    if (isFolderView) {
      if (selectedFiles.length > 0) {
        setFolderSelectedFiles(selectedFiles);
        setIsFolderViewOpen(true);
        setContextMenu({ x, y });
      } else {
        setIsFolderViewOpen(false);
      }
    } else {
      setContextMenu({ x, y });
      setIsFolderViewOpen(false);
    }

    event?.originalEvent ? event.originalEvent.preventDefault() : event.preventDefault();
  };
  const handleCloseconfirmation = () => {
    setbuttonAction({
      backend: {},
      event: '',
      index: -1,
      eventMessage: ''
    });
    setOpenConfirmation(false);
  };
  const getSelectedVideos = () => {
    let dwnldFiles = [];
    if (isFolderViewOpen) {
      folderSelectedFiles.map((item, index) => {
        if (item?.path.split('.').length > 1) {
          dwnldFiles.push({
            backendId: item.backendId,
            path: item.path
          })
        }
      })
    } else {
      let selectedFiles = [...Object.keys(selectedKey)];
      selectedFiles.map((item, index) => {
        let indexes = item.split('-').map(Number);
        let finalObj = backend_details[indexes[0]];
        for (let i = 1; i < indexes.length; i++) {
          if (finalObj && finalObj?.children) {
            finalObj = finalObj.children[indexes[i]]
          } else {
            finalObj = {}
          }
        }
        let finalObjPath = finalObj?.path || '';
        if (selected_backend_id && finalObjPath.split('.').length > 1) {
          dwnldFiles.push({
            backendId: selected_backend_id,
            path: finalObjPath
          })
        }
      })
    }
    return dwnldFiles;
  }

  const getCurrentSelectedFileDetails = () => {
    let isFolderAloneClicked;
    if (isFolderViewOpen) {
      for (let i = 0; i < folderSelectedFiles.length; i++) {
        const item = folderSelectedFiles[i];
        if (item?.path.split('.').length == 1) {
          isFolderAloneClicked = true;
        }
        if (item?.path.split('.').length > 1) {
          isFolderAloneClicked = false;
          break;
        }
      }
    } else {
      let selectedFiles = [...Object.keys(selectedKey)];
      for (let i = 0; i < selectedFiles.length; i++) {
        const item = selectedFiles[i];
        let indexes = item.split('-').map(Number);
        let finalObj = backend_details[indexes[0]];
        for (let i = 1; i < indexes.length; i++) {
          if (finalObj && finalObj?.children) {
            finalObj = finalObj.children[indexes[i]]
          } else {
            finalObj = {}
          }
        }
        let finalObjPath = finalObj?.path || '';
        if (selected_backend_id && finalObjPath.split('.').length == 1) {
          isFolderAloneClicked = true;
        }
        if (selected_backend_id && finalObjPath.split('.').length > 1) {
          isFolderAloneClicked = false;
          break;
        }
      }
    }
    return isFolderAloneClicked;
  }

  const getSelectedFolderPath = () => {
    let dwnldFiles = [];
    if (isFolderViewOpen) {
      folderSelectedFiles.map((item, index) => {
        if (item?.path.split('.').length == 1) {
          dwnldFiles.push({
            backendId: item.backendId,
            path: item.path
          })
        }
      })
    } else {
      let selectedFiles = [...Object.keys(selectedKey)];
      selectedFiles.map((item, index) => {
        let indexes = item.split('-').map(Number);
        let finalObj = backend_details[indexes[0]];
        for (let i = 1; i < indexes.length; i++) {
          if (finalObj && finalObj?.children) {
            finalObj = finalObj.children[indexes[i]]
          } else {
            finalObj = {}
          }
        }
        let finalObjPath = finalObj?.path || '';
        if (selected_backend_id && finalObjPath) {
          dwnldFiles.push({
            backendId: selected_backend_id,
            path: finalObjPath
          })
        }
      })
    }

    const uploadFolderComplete = dwnldFiles[dwnldFiles.length - 1]?.path;
    let uploadFolder = '';
    if (uploadFolderComplete?.split('.').length == 1) {
      uploadFolder = uploadFolderComplete;
    } else {
      uploadFolder = uploadFolderComplete?.split('/').slice(0, -1).join('/');
    }

    return uploadFolder;
  }
  // Handle Download action
  const handleDownload = () => {
    let downldFiles = [];
    if (isFolderViewOpen) {
      downldFiles = folderSelectedFiles;
    } else {
      downldFiles = getSelectedVideos();
    }
    download_files(downldFiles);
    setSelectedKey({});
    setContextMenu(null); // Hide context menu
  };

  const getModifiedFolderPath = (pathsList) => {
    let modifiedPathsList = pathsList.map((item, index) => {
      if (item?.path?.split('.').length > 1) {
        return item.path.split('/').slice(0, -1).join('/');
      } else {
        return item?.path;
      }
    })
    modifiedPathsList = [...new Set(modifiedPathsList)];
    return modifiedPathsList;
  }

  const getPathkey = (path) => {
    let key = ''
    if (isFolderViewOpen) {
      key = selected_node.key;
    } else {
      let selectedFiles = [...Object.keys(selectedKey)];
      for (let i = 0; i < selectedFiles.length; i++) {
        const item = selectedFiles[i];
        let indexes = item.split('-').map(Number);
        let finalObj = backend_details[indexes[0]];
        for (let i = 1; i < indexes.length; i++) {
          if (finalObj && finalObj?.children) {
            finalObj = finalObj.children[indexes[i]]
          } else {
            finalObj = {}
          }
        }
        let finalObjPath = finalObj?.path || '';
        finalObjPath = finalObjPath.split('/').slice(0, -1).join('/');
        if (selected_backend_id && finalObjPath) {
          key = item;
          break;
        }
      }
    }
    if (key?.split('-').length != path.split('/').length) {
      key = key.split('-').slice(0, path.split('/').length).join('-');
    }
    return key;
  }

  // Handle Download action
  const handleDeleteFiles = () => {
    let downldFiles = [];
    if (isFolderViewOpen) {
      downldFiles = folderSelectedFiles;
    } else {
      downldFiles = getSelectedVideos();
    }
    let payload = [...getSelectedVideos()].map((item, index) => {
      return { path: item.path }
    });
    let refresh_paths_payload = [];
    if (payload?.length > 0) {
      refresh_paths_payload = getModifiedFolderPath(payload);
    }

    if (payload.length > 0) {
      handleFolderViewChange();
      delete_files_from_folder(selected_backend_id, payload).then((data) => {
        setSelectedFiles([]);
        if (data?.deleted_files.length > 0) {
          triggerAlert("Success", "Success", `Files are deleted.`);
          refresh_paths_payload.map((item, index) => {
            const path_key = getPathkey(item);
            getDetailsOfBackends(selected_backend_id, 1, item, path_key);
            getFileDtails(selected_backend_id, item)
          })
        } else {
          triggerAlert("Error", "Delete Error", `Cannot Delete Folders`);
        }
        handleCloseconfirmation();
      });
    } else {
      triggerAlert("Error", `Cannot Perform Delete Operation Other Than Files.`);
    }
    setSelectedKey({});
    setContextMenu(null); // Hide context menu
  };



  const handleSelectedFiles = (e) => {
    let lists = [...selectedFiles];
    if (e.target.checked) {
      lists.push(e.target.value);
    } else {
      lists = lists.filter((item) => item !== e.target.value);
    }
    setSelectedFiles(lists);
  }
  const getAllSavedCollections = () => {
    get_all_collections().then(data => {
      setCollections(data);
    })
      .catch(error => console.log(error));
  }

  const get_file_details = (backendId, path) => {
    Promise.all([
      fetch(`/api/v1/fetch/thumb/${backendId}/${path}`, {
        method: "GET",
      }).then(response => response.blob())
        .then(data => {
          let objectURL = URL.createObjectURL(data);
          setThumbnail(objectURL);
          console.log(data);
        })
        .catch(error => console.log(error)),

      fetch(`/api/v1/fetch/details/${backendId}/${path}`, {
        method: "GET",
      }).then(response => response.json())
        .then(data => {
          console.log(data);
          setFileDetails(data);
        })
        .catch(error => console.log(error))
    ])
  }

  // right click button functions

  const handleCreateNewCollection = (event) => {
    event.preventDefault();
    createNewCollection(request).then(data => {
      closeModal();
      handleAddFilesToCollection(data.id);
      setRequest({
        label: ""
      });
      getAllSavedCollections(); // get_all_saved_collections();
    })
  }
  const handleCreateNewFolder = (event) => {
    event.preventDefault();
    let reqpayload = {
      path: `${selectedPath}/${folderReq.path}`
    }
    create_new_folder(selected_backend_id, reqpayload).then(data => {
      handleClose();
      setFolderReq({
        path: ""
      });
      if (selected_node.path == selectedPath) {
        getDetailsOfBackends(selected_backend_id, 1, selectedPath, selected_node.key); // get_all_saved_collections();
      } else {
        triggerAlert("Error", "Path MisMatch", `Selected & Expanded Paths are different`);
      }
    })
  }

  const getSelectedFiles = (isDownload) => {

    const filteredLists = explorer_details.filter((node) => selectedFiles.includes(node.label));
    const finalLists = filteredLists.map((node) => {
      let data = {
        label: node.label,
        path: node.path,
        backendId: selected_backend_id,
      };
      if (isDownload) {
        data["is_dir"] = node.is_dir;
      }
      return data;
    })

    return finalLists;
  }


  const handleAddFilesToCollection = (collectionId) => {
    let payload = getSelectedFiles()
    if (payload && payload.length > 0) {
      add_videos_to_collection(collectionId, payload).then(data => {
        triggerAlert("Success", "Success", `Files added to collection.`);
      })
        .catch(error => console.log(error));
    }
  }

  const create_new_Folder = (event) => {
    event.preventDefault();
    let reqpayload = {
      path: `${selectedPath}/${folderReq.path}`
    }
    create_new_folder(selected_backend_id, reqpayload).then(data => {
      handleClose();
      setFolderReq({
        path: ""
      });
      if (selected_node.path == selectedPath) {
        getDetailsOfBackends(selected_backend_id, 1, selectedPath, selected_node.key); // get_all_saved_collections();
      } else {
        triggerAlert("Error", `Selected & Expanded Paths are different`);
      }
    })
  }

  const onSelectionChange = (e,directUpdate=false) => {
    setContextMenu(null);
    const isCtrl = e?.originalEvent?.ctrlKey;
    const isShift = e?.originalEvent?.shiftKey;
    const clickedKey = Object.keys(e.value).pop(); // current clicked node key

    const clickedIndex = flatNodes.findIndex(node => node.key === clickedKey);
    if (clickedIndex === -1) return;

    if (isCtrl && isShift && lastSelectedIndex !== null) {
      // Select range
      const newSelected = { ...selectedKey };

      const start = Math.min(lastSelectedIndex, clickedIndex);
      const end = Math.max(lastSelectedIndex, clickedIndex);

      for (let i = start; i <= end; i++) {
        if (!flatNodes[i].is_dir) {
          newSelected[flatNodes[i].key] = true;
        }
      }

      setSelectedKey(newSelected);
    } else if (isCtrl) {
      setSelectedKey(e.value);
      setLastSelectedIndex(clickedIndex);
    }  else if (directUpdate) {
      setSelectedKey(e.value);
      setLastSelectedIndex(clickedIndex);
    } else {
      setLastSelectedIndex(clickedIndex);
      setSelectedKey({
        [Object.keys(e.value)[
          Object.keys(e.value).length - 1
        ]]: true,
      });
    }
  }



  return (
    <>
      <div className="container-fluid g-0 explorerContainer" onClick={() => setContextMenu(null)}>
        <AlertPopup />
        <div className="row g-0">
          <div className="col-3 col-md-3">
            <div style={{ backgroundColor: "#f8f9fa" }}>
              <div className="card h-100 rounded-0  border-top-0 border-bottom-0 border-start-0 bg-transparent">
                <div className="card-header d-grid gap-2 px-2.5 py-[7px] pb-[5px]">
                  <button className="btn btn-block btn-dark px-1.5 py-1 text-sm" data-bs-toggle="modal" data-bs-target="#addStorageModal">Add Storage</button>
                </div>
                <div className="card-body p-0">
                  <div style={{ height: "calc(100vh - 115px)", overflow: "auto" }}>
                    <ul className="list-group">
                      {backend_lists.map((backend, index) => (
                        <li
                          key={index}
                          className={backendId === backend.id ? 'list-group-item d-flex justify-content-between align-items-center  cursor-pointer explorer-list-group active px-4 py-2' : "list-group-item d-flex justify-content-between align-items-center  cursor-pointer explorer-list-group px-4 py-2"}
                          onClick={() => { dispatch(setBackendId(backend.id)); getDetailsOfBackends(backend.id, 1, "", 0) }}
                        >
                          <div className='overflow-hidden text-ellipsis whitespace-nowrap text-[0.825rem] w-[22vw] truncate overflow-text-wrap'>
                            {
                              ['local', 'Local'].includes(backend.type) ? <img src={LocalServer} className="svg-icon-backend-type" alt="Local Server" /> : ['s3', 'S3'].includes(backend.type) ? <S3Icon /> : backend.type === 'Sharepoint' ? <SharePointIcon /> : ''
                            }
                            {backend.backend_name}

                          </div>
                          <div className="controller-container">
                            <span className="badge text-bg-dark rounded-pill">{backend.type}</span>
                            {/* ${selected_backend_id==backend.id ? "editStorageButton" :"editStorageButton"} */}
                            <button className={`controlbuttons editStorageButton`} onClick={() => handleEditBackend(backend, index)} data-bs-toggle="modal" data-bs-target="#addStorageModal">
                              <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                            <button className="controlbuttons deleteStorageButton" onClick={() => handleButtonEventRemoveDelete('Delete', backend, index)}>
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                            {/* <button className="controlbuttons">{backend.type}</button> */}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <ConfirmationModal isThisCenterAligned={true} buttonAction={buttonAction} open={open} handleClose={handleClose} handleSubmitConfirmation={handleSubmitConfirmation} />
          <div className="col-9 col-md-9">
            <Splitter>
              <splitterPanel size={30} style={{ backgroundColor: "#f8f9fa" }} className="flex align-items-center justify-content-center" >
                <div ref={panelRef} style={{ height: "calc(100vh - 60px)", backgroundColor: "#f8f9fa", overflow: "auto", width: "100%" }}>
                  <div className="card h-100 rounded-0 border-top-0 border-bottom-0 border-0 bg-transparent">
                    <div className="card-body p-1 file-viewer card-body-container"
                    // style={{ maxWidth: maxWidth ?? "100%" }}
                    >
                      <Tree
                        value={backend_details}
                        className="width-full-tree"
                        selectionMode="multiple"
                        selectionKeys={selectedKey}
                        onSelectionChange={onSelectionChange}
                        nodeTemplate={(node, options) => {
                          const isSelected = !!selectedKey[node.key];

                          const handleCheckboxChange = (e) => {
                            const updatedSelection = { ...selectedKey };

                            if (e.target.checked) {
                              updatedSelection[node.key] = true;
                            } else {
                              delete updatedSelection[node.key];
                            }
                            onSelectionChange({ value: updatedSelection },true);
                          };

                          return (
                            <span
                              className={options.className}
                              title={node.label}
                              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                            >
                              {!node.is_dir && (
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={handleCheckboxChange}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              )}
                              {node.is_dir ? node.label.replace("/", "") : node.label}
                            </span>
                          );
                        }}
                        onExpand={(e) => {
                          setContextMenu(null);
                          getDetailsOfBackends(
                            selected_backend_id,
                            1,
                            e.node.path.includes('/') ? e.node.path : e.node.path,
                            e.node.key
                          );
                          setSelectedNode(e.node);
                        }}
                        onSelect={(e) => {
                          setContextMenu(null);
                          if (!e.node.is_dir) getFileDtails(selected_backend_id, e.node.path);
                          setSelectedNode(e.node);
                        }}
                        onContextMenu={(e) => handleRightClick(e)}
                        loading={loading}
                        emptyMessage="No directories or files found"
                      />

                    </div>
                  </div>
                </div>
              </splitterPanel>

              <SplitterPanel size={70} style={{ backgroundColor: "#f8f9fa" }} className="flex align-items-center justify-content-center">
                <div style={{ height: "calc(100vh - 60px)", backgroundColor: "#f8f9fa", overflow: "auto" }}>
                  <div className="card h-100 rounded-0 border-0">
                    <div className="card-body p-1">
                      {isFileView && <FileDetailedView data={{ fileDetails, thumbnail, isLoading, selected_backend_id, completePath, tagsList, setTagsList, mappedTags, setMappedTags, inputValue, setInputValue, completePath, selected_backend_id }} />}

                      {/* {isFolderView && <FileExplorerView data={{ explorer_details, selected_backend_id, selectedPath, getDetailsOfBackends, selectedKey, selected_node, getFileDtails, handleFolderViewChange, handleFileViewChange, handleRightClick: handleRightClick }} />} */}
                    </div>
                  </div>
                </div>
              </SplitterPanel>
            </Splitter>
          </div>
        </div>
        <Modal
          open={openModalType != ''} onClose={handleCloseModal}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
          BackdropProps={{
            invisible: true,
          }}
          className="ContainerForExplorer"
        >
          <Box sx={{
            ...modalStyle, width: 560, top: '45%', overflowY: 'auto', height: 'auto', textAlign: 'center'
          }}>
            <div className="containerForModalSelector">
              <h5>{openModalType == 'upload' ? <>Upload Files to : <b className="folder-path">{getSelectedFolderPath()}</b></>
                : openModalType == 'create_folder' ? <>Create New Folder inside of : <b className="folder-path">{getSelectedFolderPath()}</b></>
                  : openModalType == 'add_to_collection' ? "Collections"
                    : "Tags"}</h5>
              <button
                className='toastCloser'
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            {openModalType == 'upload' ?

              <MultiFileUploadWithBottomProgressBar
                backendId={selected_backend_id}
                getSelectedFolderPath={getSelectedFolderPath}
                openAlertPopup={triggerAlert}
                get_file_details={get_file_details}
                get_details_of_backends={getDetailsOfBackends}
                getPathkey={getPathkey}
                handleCloseModal={handleCloseModal}
              />
              :
              openModalType == 'create_folder' ?
                <div className="modal-body">
                  <form onSubmit={(e) => create_new_Folder(e)}>
                    <div className="mb-3">
                      {/* <label htmlFor="collectionName" className="form-label">New Folder name</label> */}
                      <input
                        type="text"
                        className="form-control"
                        id="collectionName"
                        placeholder={`Enter Folder name`}
                        value={folderReq?.path}
                        required
                        autoComplete="c-name"
                        onChange={(e) => setFolderReq({ path: e.target.value })}
                      />
                    </div>

                    <div className="d-flex justify-content-end">
                      <button className="btn btn-sm btn-outline-secondary me-2" onClick={handleCloseModal}>Close</button>
                      <button className="btn btn-sm btn-primary" type="submit">Create Folder</button>
                    </div>
                  </form>
                </div>
                :
                openModalType == 'add_to_collection' ?
                  <CustomizedTagSelector elementsData={{
                    elementsList: collectionsList,
                    setElementsList: setCollectionsList,
                    mappedElements: mappedCollection1,
                    setMappedElements: setMappedCollection1,
                    inputValue: inputValue,
                    setInputValue: setInputValue,
                    videos: getSelectedVideos(),
                    title: 'Collections',
                    disablePortal: false
                  }} />
                  : <CustomizedTagSelector elementsData={{
                    elementsList: tagsList,
                    setElementsList: setTagsList,
                    mappedElements: mappedTags1,
                    setMappedElements: setMappedTags1,
                    inputValue: inputValue,
                    setInputValue: setInputValue,
                    videos: getSelectedVideos(),
                    title: 'Tags',
                    disablePortal: false
                  }} />
            }
          </Box>
        </Modal>
        {contextMenu && (
          <div
            className="custom-context-menu"
            style={{
              position: 'fixed',
              top: `${contextMenu.y}px`,
              left: `${contextMenu.x}px`,
            }}
          >
            {getCurrentSelectedFileDetails() == false && <button onClick={handleDownload}>Download</button>}
            {getCurrentSelectedFileDetails() == false && <button onClick={handleOpenCollectionModal}>Add to Tag</button>}
            {getCurrentSelectedFileDetails() == false && <button onClick={() => handleOpenCollectionModal('add_to_collection')}>Add to Collection</button>}
            {/* <button className="danger" onClick={handleDeleteFiles}>Delete</button> */}
            {getCurrentSelectedFileDetails() == false && <button className="danger" onClick={() => handleButtonDeleteFiles('Delete Files')} >Delete</button>}

            {getCurrentSelectedFileDetails() == true && <button onClick={() => handleOpenCollectionModal('create_folder')}>Create New Folder</button>}
            {getCurrentSelectedFileDetails() == true && <button onClick={() => handleOpenCollectionModal('upload')}>Upload Files</button>}
          </div>
        )}


      </div>
      <AddStorageModal editBackend={editBackend} getAllBackends={getAllBackends} request={request} setRequest={setRequest} handleCloseEdit={handleCloseEdit} testConnectionStatus={testConnectionStatus} setTestConnectionStatus={setTestConnectionStatus} />
      {/* Context Menu for download action */}
    </>
  );
};
